// src/pages/Historic.js
import React, { useState, useEffect } from 'react';
import customers from './conf/Customers';
import CustomerStyles from './conf/CustomerStyles';
import { formatDateToStringHistoric } from './conf/utils';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { getAllItems } from './conf/bdd';
import { writeLogMsg } from './conf/log';

function Historic() {
    writeLogMsg('Historic page');
      const [selectedCustomer, setSelectedCustomer] = useState(customers.shortlist.find(item => item.id.toString() === localStorage.getItem('customer')) || customers.shortlist.find(item => item.label === global.APP_DEFAULT_CUSTOMER) || customers.shortlist[0]);
    CustomerStyles(selectedCustomer);
    const { t } = useTranslation();
    const navigation = useNavigate();
    const [allItems, setAllItems] = useState([]);
    const [showByDate, setShowByDate] = useState(true);
    
    const [expandedCustomer, setExpandedCustomer] = useState(null);
    const [groupedData, setGroupedData] = useState([]);
    
    const [isOnline, setIsOnline] = useState(navigator.onLine);

    const toggleCustomer = (id) => {
        setExpandedCustomer(expandedCustomer === id ? null : id);
    };

    useEffect(() => {
        const loadData = async () => {
            try {
                writeLogMsg('Historic : getAllItems called');
                const data = await getAllItems();
                writeLogMsg('Historic : setAllItems called');
                setAllItems(data);
                writeLogMsg('Historic : allItems:', data);
                
                setAllItems(data.sort((a, b) => new Date(b.ValidationDate) - new Date(a.ValidationDate)));
                
                setGroupedData(groupShipmentsByCustomer(data));

            } catch (error) {
                console.error('Historic : Erreur lors de la récupération des données:', error);
            }
        };
        loadData();
    }, []);

    useEffect(() => {
        const handleOnline = async () => {
        setIsOnline(true);
        writeLogMsg('Historic: handleOnline: Vous êtes en ligne !');

        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
            navigator.serviceWorker.controller.postMessage({ type: 'P4C_SYNC_ONLINE' });
            writeLogMsg('Historic: handleOnline: Envoi du message de synchronisation au service worker');
        } else {
            writeLogMsg('Historic: handleOnline: Service worker non disponible ou pas contrôleur actif');
        }

        };

        window.addEventListener('online', handleOnline);

        return () => {
        window.removeEventListener('online', handleOnline);
        };
    }, []);

    const toggle = () => {
        navigation("/");
    };

    const handleDate = () => {
        writeLogMsg('Historic: Sort by date');
        writeLogMsg('Historic: allItems:', allItems);
        setShowByDate(true);
    };

    const handleCarrier = () => {
        writeLogMsg('Historic: Sort by carrier');
        writeLogMsg('Historic: groupedData:', groupedData);
        setShowByDate(false);
    };

    // Fonction pour regrouper les expéditions par client
    const groupShipmentsByCustomer = (data) => {
        const grouped = {};
        data.forEach(entry => {
            const customerCode = entry.Customer.id;
            if (!grouped[customerCode]) {
                grouped[customerCode] = {
                    customer: entry.Customer,
                    shipments: []
                };
            }
            grouped[customerCode].shipments.push(entry);
        });
        return Object.values(grouped);
    };

    const getStatusLabel = (shipment) => {
        var label = "";
        writeLogMsg('Historic: getStatusLabel: shipment:', shipment);
        for (var i = 0; i < shipment.Customer.statusList.length && label === ""; i++) {
            var status = shipment.Customer.statusList[i];
            if (status.code === shipment.Status) {
                label = t(status.lang + "_COMP") + " ";
            }
        }
        if (label === "") {
            label = shipment.Status;
        }
        return label;
    };
  
    useEffect(() => {
        const handle = () => navigation("/");
  
        window.addEventListener("app-back", handle);
        return () => window.removeEventListener("app-back", handle);
    }, [navigation]);
  
    return (
        <div id="mainDiv" style={{position : 'static'}} >
            <div>
                {/* Navigation bar */}
                <nav className="navbar navbar-default col-sm-12" role="navigation" style={{ display: 'flow-root', backgroundColor: '#4c4c4b' }}>
                    <div className="menu-icon menu-icon-arrow float-left is-opened" onClick={toggle}>
                        <span />
                    </div>
                    <div className="col-sm-6"  >
                        <label className="historic-title">{t('HISTORIC')}</label>
                    </div>
                </nav>

                {/* Ask for Delivery or Collect ? */}
                <div className="col-sm-10 col-lg-8 mx-auto">

                    {/* No information label */}
                    {allItems.length === 0 && (
                        <div className="loading_text">
                            <h4 >{t('HISTORIC_NODATA')}</h4>
                        </div>
                    )}

                    {/* Sort selection buttons */}
                    {allItems.length > 0 && (
                        <div className="form-group col-sm-12">   
                            <div className="btn-group btn-group-justified blocks btn-group-sort col-sm-12">
                                <label className="btn btn-radio historic-toggle col-sm-6" onClick={handleDate} style={{ backgroundColor: showByDate ? 'white' : '#4c4c4b', color: showByDate ? 'black' : '#999999', borderColor: '#666666', display: 'flex', alignItems: 'center' }} >
                                    {t('SORT_DATE')}
                                </label>
                                <label className="btn btn-radio historic-toggle col-sm-6" onClick={handleCarrier} style={{ backgroundColor: showByDate ? '#4c4c4b' : 'white', color: showByDate ? '#999999' : 'black', borderColor: '#666666', display: 'flex', alignItems: 'center' }}>
                                    {t('SORT_CARRIER')}
                                </label>
                            </div>
                            {/* Historic list */}
                            {showByDate && (
                                <div className="col-sm-12">
                                    {allItems.map((item) => (    
                                        <div key={item.id}>
                                            <div className={`historic-${item.Customer.name}`}>
                                                {/*Header : Date & customer logo */}
                                                <div className="historic-header-bydate py-1 px-2" style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                                    <label className="mb-0 pt-0" style={{fontSize:'0.75rem'}}>{formatDateToStringHistoric(new Date(item.ValidationDate))}</label>
                                                    <img
                                                        src={`assets/images/xhdpi/logo-header-${item.Customer.name}.png`}
                                                        srcSet={`assets/images/mdpi/logo-header-${item.Customer.name}.png 320w,
                                                                assets/images/hdpi/logo-header-${item.Customer.name}.png 480w,
                                                                assets/images/xhdpi/logo-header-${item.Customer.name}.png 640w,
                                                                assets/images/xxhdpi/logo-header-${item.Customer.name}.png 960w`}
                                                        alt={`Logo ${item.Customer.name}`}
                                                        className="img"
                                                    />
                                                </div>
                                                {/* Shipment detail */}
                                                <div className="historic-detail">
                                                    <div>
                                                        <span>{item.ShipmentNumber}</span><br />
                                                        <span>{item.ConsigneeName}</span><br />
                                                        <span>{item.ConsigneeAddress1}</span><br />
                                                        <span>{item.ConsigneeAddress2}</span><br />
                                                        <span>{item.ConsigneePostalCode} {item.ConsigneeTown}</span>
                                                    </div>
                                                    <div className="historic-status">
                                                        {getStatusLabel(item)}
                                                        <span className={`glyphicon glyphicon-off glyphicon-transfer ${!item.Sent ? 'transfer-disabled' : ''}`}></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                            {!showByDate && (
                                <div className="col-sm-12">
                                    {groupedData.map((group) => (
                                        <div key={group.customer.id} style={{ marginBottom: '5px' }}>
                                            <div className={`historic-${group.customer.name}`}>
                                                <div className="historic-header-bycarrier" style={{ display: 'flex', alignItems: 'center'}} onClick={() => toggleCustomer(group.customer.id)}>
                                                    <div className="pull-left historic-header-bycarrier pos col-2">
                                                        <label className="position-nb">{group.shipments.length}</label>
                                                        <label className="position-label">{t('HISTORIC_POS')}</label>
                                                    </div>
                                                    <div className="col-8">
                                                        <img
                                                            src={`assets/images/xhdpi/logo-header-${group.customer.name}.png`}
                                                            srcSet={`assets/images/mdpi/logo-header-${group.customer.name}.png 320w,
                                                                    assets/images/hdpi/logo-header-${group.customer.name}.png 480w,
                                                                    assets/images/xhdpi/logo-header-${group.customer.name}.png 440w,
                                                                    assets/images/xxhdpi/logo-header-${group.customer.name}.png 960w`}
                                                            alt={`Logo ${group.customer.name}`}
                                                        />
                                                    </div>
                                                    <div className="col-2">
                                                        <i className={`glyphicon ${(group.customer.id === expandedCustomer) ? 'glyphicon-chevron-down' : 'glyphicon-chevron-right'}`}></i>
                                                    </div>
                                                </div>
                                                {expandedCustomer === group.customer.id && (
                                                    <div className={`historic-${group.customer.name}`}>
                                                        {group.shipments.map((item) => (
                                                            <div key={item.id} className='historic-detail' style={{ marginBottom: '5px' }}>
                                                                <div>
                                                                    <span style={{fontWeight : 'bold'}}>{formatDateToStringHistoric(new Date(item.ValidationDate))}</span><br />
                                                                    <span>{item.ShipmentNumber}</span><br />
                                                                    <span>{item.ConsigneeName}</span><br />
                                                                    <span>{item.ConsigneeAddress1}</span><br />
                                                                    <span>{item.ConsigneeAddress2}</span><br />
                                                                    <span>{item.ConsigneePostalCode} {item.ConsigneeTown}</span>
                                                                </div>
                                                                <div className="historic-status">
                                                                    {getStatusLabel(item)}
                                                                    <span className={`glyphicon glyphicon-off glyphicon-transfer ${!item.Sent ? 'transfer-disabled' : ''}`}></span>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default Historic;